const setPermissions = (store, permissions) => {
  store.commit('setPermissions', permissions)
}

export default {
  setPermissions
}
